import styled from 'styled-components';
import { colors } from '../../Components/StylesGlobales/Colors';

export const ContainerProjects = styled.div`
  padding-top: 7rem;
  @media (max-width: 768px) {
    padding-top: 5rem;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 30px;

  span {
    font-size: 40px;
    font-weight: 700;
    line-height: 2.4rem;
    background: linear-gradient(135deg, #d6ff7f 0%, #00b3cc 100%);
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
  }
`;

export const ContentProject = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ProjectContent = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleProject = styled.h3`
  padding: 8px 15px;
  font-weight: 700;
  font-size: 25px;
  text-align: center;
  margin-bottom: 10px;
  color: ${colors.TEXT_WHITE};
  background: linear-gradient(
    135deg,
    rgb(102, 153, 255) 0%,
    rgb(255, 51, 102) 100%
  );
  box-shadow: ${colors.BOX_SHADOW_BLUE};
  text-decoration: none;
`;

export const ContainerImage = styled.div`
  img {
    width: 100%;
    margin: 0 auto;
    box-shadow: ${colors.BOX_SHADOW_BLUE};
    border-radius: 5px;
  }
  @media (max-width: 768px) {
    img {
      max-width: 100%;
    }
  }
`;

export const ContainerTechs = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  justify-content: center;
  font-size: 25px;
  /* p {
    margin-top: 2px;
    font-size: 13px;
    color: ${colors.TEXT_GREY_NEUTRAL};
  } */
`;

export const Description = styled.div`
  margin-top: 10px;
  text-align: center;
`;

export const ContainerLocation = styled.div`
  display: flex;
  justify-content: flex-end;
  align-content: space-around;
  margin-top: 10px;
  img {
    background-color: white;
    border-radius: 50%;
    width: 35px;
  }
  a:first-of-type {
    padding-right: 15px;
  }
`;
